export default "__VITE_ASSET__DfAPIPqF__"